import React from 'react';
import Menu from '../../../components/globalComponents/headerMenu/menu';
import ContactUs from '../../../components/companyInfoComponents/contactUs/contactUs';
import SocialIcons from '../../../components/globalComponents/socialIcons/socialIcons';
import GradientLine from '../../../components/globalComponents/gradientLine/gradientLine';
import Footer from '../../../components/globalComponents/footer/footer';
import './servicesInfoPage.scss';
import ServicesInfoHeader from '../../../components/servicesInfoComponents/servicesInfoHeader/servicesInfoHeader';
import ServicesInfoCompany from '../../../components/servicesInfoComponents/servicesInfoCompany/servicesInfoCompany';
import ServicesWonderaly from '../../../components/servicesInfoComponents/servicesWonderaly/servicesWonderaly';
import ServicesClients from '../../../components/servicesInfoComponents/servicesClients/servicesClients';
import ClientsSection from '../../../components/servicesInfoComponents/clientsSection/clientsSection';

const ServicesInfoPage = () => {
  return (
    <>
      <Menu />
      <div className="">
        <ServicesInfoHeader />
        <ServicesInfoCompany />
        <ServicesWonderaly />
        <hr className="divider diverdermedia" />
        <ServicesClients />
        <ClientsSection />
      </div>
      <ContactUs />
      <SocialIcons />
      <GradientLine />
      <Footer />
    </>
  );
};

export default ServicesInfoPage;
